import { render } from "./UserLimit.vue?vue&type=template&id=0930a604&scoped=true"
import script from "./UserLimit.vue?vue&type=script&lang=js"
export * from "./UserLimit.vue?vue&type=script&lang=js"

import "./UserLimit.vue?vue&type=style&index=0&id=0930a604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0930a604"]])

export default __exports__